import React from 'react'
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
export default function Error() {
  return (
    <div className="error-div">
      <Result
        status="403"
        title="403"
        subTitle="对不起,您无权访问此页面"
        extra={<Link to="/login"><Button type="primary">登&nbsp;&nbsp;&nbsp;&nbsp;录</Button></Link>}
      />
    </div>
  )
}
